import React from 'react';
import ReactDOM from 'react-dom';
import posthog from 'posthog-js';
import App from './App';
import './global.css'
import reportWebVitals from './reportWebVitals';
import "@fontsource/inter";
import { verifyToken } from './utils/utils';
import store from './utils/store';

// Initialize PostHog
const POSTHOG_TOKEN = process.env.REACT_APP_POSTHOG_TOKEN;

if (!POSTHOG_TOKEN) {
  console.warn('PostHog token not found in environment variables');
}

if (!window.location.host.includes('127.0.0.1') && !window.location.host.includes('localhost')) {
  posthog.init(POSTHOG_TOKEN, { api_host: 'https://us.i.posthog.com', person_profiles: 'identified_only' })
}

// Add global error handling for auth errors
window.addEventListener('unhandledrejection', async (event) => {
  // Check if error is auth related
  if (event.reason?.message?.includes('security token')) {
    event.preventDefault(); // Prevent default error handling
    
    try {
      // Try to refresh the token
      const refreshToken = store.getItem('refreshToken');
      if (refreshToken) {
        await verifyToken();
        // If successful, reload the page to retry the failed request
        window.location.reload();
        return;
      }
    } catch (e) {
      // If refresh fails, clear storage and redirect to login
      store.clear();
      window.location.href = '/login';
    }
  }
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
